import { BsSearch } from 'react-icons/bs';
import Input from "./Input";

const SearchInput = ({value = "", onChange, inputProps, borderless}) => <Input placeholder="Search here..." value={value} onChange={onChange} startIcon={BsSearch} inputProps={inputProps} borderless={borderless}/>

export default SearchInput;